(ns frontend.view.dashboard.oppos-per-user.view
  (:require
   [common.localization :as loc]
   [frontend.view.components.bar-chart :as bar-chart]
   [frontend.view.components.bar-chart]
   [frontend.view.components.oppos-per-users-chart :as users-chart]
   [frontend.view.components.top-performer-chart :as top-performer-chart]
   [ui.components.card.view :as card]
   [ui.components.chart.view :as chart]))

(defn component
  [data]
  [:div
   [card/card
    [card/header (loc/tr :home-active-cases)]
    [card/body
     [:div
      {:class "col-span-5"}
      [chart/view
       (users-chart/options
        {:largest-bar-color "#8ABF4C"
         :height            200}
        (get-in data [:active-cases :per-user]))]]
     [:div
      {:class "col-span-5"}
      [top-performer-chart/component
       {:color "#8ABF4C"}
       (get-in data [:active-cases :top-performer])]]
     [:div
      {:class "col-span-10"}
      [chart/view
       (bar-chart/options
        {:grid-line-color  "#3C3D39"
         :background-color "#32332F"
         :labels-color     "#82867B"
         :series-color     "#8ABF4C"
         :height           200}
        (get-in data [:per-pipeline-stage]))]]]]])
